import { takeLatest, call, put, select } from 'redux-saga/effects';
import { t } from 'utils/translates';
import {
  requestInProcess,
  requestFinished,
  sendRequest,
  requestRecoveryForm,
  selectFieldNoticeSubscribe,
  recoveryFormFields
} from '../../../../common/reducers/userNoticesSubscribeForm';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import TasksExecsService from '../../../../services/EventsUserNoticeSubscribeService';
import * as clientNoticesActions from '../../../../../main/reducers/static/states/clientNotices/reducer';

function* recoverySubscribeForm(reducerName) {
  yield put(requestInProcess(reducerName));
  try {
    const result = yield call(
      timeoutCall,
      TasksExecsService.getNoticeSubscribeByAuthUser
    );
    if (result.response.status === 200) {
      yield put(
        recoveryFormFields(reducerName, {
          notice_subscribe: result.destructData
        })
      );
    }
    yield put(requestFinished(reducerName));
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
}

function* setSubscribeForm(reducerName) {
  yield put(requestInProcess(reducerName));
  const formBody = yield select(selectFieldNoticeSubscribe, reducerName);
  try {
    const result = yield call(
      timeoutCall,
      TasksExecsService.setNoticeSubscribeByAuthUser,
      formBody.value
    );
    if (result.status === 200) {
      yield put(
        clientNoticesActions.addClientNotice({
          type: 'success',
          message: t('Настройки уведомлений сохранены')
        })
      );
    }
    yield put(requestFinished(reducerName));
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
}

export default function getSaga(reducerName) {
  return [
    takeLatest(
      requestRecoveryForm(reducerName).type,
      recoverySubscribeForm,
      reducerName
    ),
    takeLatest(sendRequest(reducerName).type, setSubscribeForm, reducerName)
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/events/reducers/static/forms/sagas/userNoticesSubscribeFormSaga.js